<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="formComponent"
        tourists-label="tourist"
        show-dates
        show-days-count
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import InsuranceSearchForm from '~/components/insurance/search/forms/InsuranceSearchForm.vue'

    @Component({
        components: {
            SearchSummaryLayout,
            InsuranceSearchForm,
        },
    })
    export class InsuranceSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        get locationLabel() {
            return `${insuranceRuntimeStore.location.name}`
        }

        get formComponent() {
            return resolveComponent('InsuranceSearchForm')
        }
    }

    export default InsuranceSearchSummary
</script>
